import "./SideBar.css";
import SidebarContent from "./SidebarContent";
import SidebarHeader from "./SidebarHeader";

function SideBar() {
  return (
    <>
      <div
        className="d-none d-md-flex flex-column flex-shrink-0 p-3 sidebar-container"
        style={{
          width: "280px",
          boxShadow: "5px 0px 5px -5px #888",
          background: "white",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <div className="mb-3">
          <SidebarHeader />
        </div>
        <SidebarContent />
      </div>
    </>
  );
}

export default SideBar;
